import React from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { setLocale } from '../../actions/intl';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import { closeHeaderModal } from '../../actions/siteadmin/modalActions';

import { formatLocale, isRTL } from '../../helpers/formatLocale';
import bt from '../../components/commonStyle.css';
import s from './LanguageModal.css';

const LanguageModal = () => {
  const dispatch = useDispatch();

  const currentLocale = useSelector(state => state.intl.locale);
  const availableLocales = useSelector(state => state.runtime.availableLocales);
  const localeList = availableLocales?.filter(locale => locale !== currentLocale);

  const handleChange = async (value) => {
    const isRtlLocale = value && isRTL(value);

    dispatch(closeHeaderModal('languageModal'));

    if (isRtlLocale) {
      document.body.classList.add('rtl');
    } else if (isRTL(currentLocale) && !isRtlLocale) {
      document.body.className = document.body.className.replace(/\brtl\b/g, '');
    }

    dispatch(setLocale({ locale: value }));

    moment.defineLocale(`${value}-dup`, {
      parentLocale: isRtlLocale ? value : 'en',
      preparse: string => string,
      postformat: string => string,
    });
  };

  return (
    <div className={bt.languageModalGrid}>
      <div onClick={() => dispatch(closeHeaderModal('languageModal'))}  >
        <div className={cx(bt.activeItem, bt.activeSection)}>
          {formatLocale(currentLocale)}
        </div>
      </div>

      {localeList && localeList.map((item, key) => (
        <div key={key} onClick={() => handleChange(item)} >
          <div className={cx(bt.activeItem)}>
            {formatLocale(item)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default withStyles(bt, s)(LanguageModal);
